<h1 mat-dialog-title *ngIf="data.title">{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button color="primary" [mat-dialog-close]="true" (click)="onAcceptClick()" tabindex="2">Aceptar</button>
  <button mat-button color="light" (click)="onNoClick()" tabindex="-1">Cancelar</button>
</div>